module.exports = __webpack_public_path__ + "static/media/logo_cuc.2cabedb7.png";